define((require) => {
    "use strict";

    const _                    = require("underscore");
    const DomHandler           = require("ui/experience/widgets/textWidget/textEditor/DomHandler");
    const WebFontsUtil         = require("shared/ui/experience/fonts/WebFontsUtil");
    const TextWidgetView       = require("shared/ui/experience/widgets/textWidget/TextWidgetView");
    const TextEditorController = require("ui/experience/widgets/textWidget/textEditor/TextEditorController");

    /**
     * This class decorates the Text Widget with text inline editor
     */
    return TextWidgetView.extend({
        /**
         * A flag indicating whether a mouse down is a click(vs a drag)
         * @private
         */
        _isClick: false,

        /**
         * A flag indicating whether the widget is in selected state by FreeTransform
         * @private
         */
        _isSelected: false,

        _cursorCoordinatesOnMouseDown: null,

        /**
         * The reference to the text widget inline editor
         */
        textEditorController: null,

        /**
         * Initialization
         */
        initialize() {
            this.__super();

            // There is no way to determine deselect, so we need to get it from FreeTransform
            this.listenTo(this, "deselect", this._deselectHandler);

            // Overwrites the change event on the AbstractView level
            TextWidgetView.prototype.modelEvents.change = this._changeHandler;

            this._cursorCoordinatesOnMouseDown = {};
        },

        _changeHandler(model, option) {
            // For advanced text widget, we need to prevent rendering while it is being edited
            if (option.render !== false) {
                this.render();
            }
        },

        /**
         * Use mousedown, mousemove and mouseup to determine whether if a click is a reselect.
         * We need reselect event to enable the editor
         * @private
         */
        events: {
            mousedown: "_mouseDownHandler",
            mousemove: "_mouseMoveHandler",
            mouseup: "_mouseUpHandler"
        },

        /**
         * @see events
         * @private
         */
        _mouseDownHandler(event) {
            this._isClick = true;
            this._cursorCoordinatesOnMouseDown.x = event.pageX;
            this._cursorCoordinatesOnMouseDown.y = event.pageY;
        },

        /**
         * @see events above
         * @private
         */
        _mouseMoveHandler(event) {
            // Only cancel the click event if the cursor was actually moved. This is workaround for
            // this bug in Chrome: https://code.google.com/p/chromium/issues/detail?id=161464
            // See also FreeTransform.js.
            if (event.pageX !== this._cursorCoordinatesOnMouseDown.x ||
                event.pageY !== this._cursorCoordinatesOnMouseDown.y) {
                this._isClick = false;
            }
        },

        /**
         * @see events above
         * @private
         */
        _mouseUpHandler() {
            if (this._isClick) {
                this._clickedHandler();
            }
            // if mouse up on the widget, it should always be selected
            this._isSelected = true;
            // Note: A nasty hack, could not find a better solution, see bug MOS-1822
            // Reason: sometimes when a text widget is dragged, it does not fire a click event, consequently the
            // inactive scene does not activate itself. This only happens when a text widget has nested elements,
            // namely after being edited. It is fine with newly created text widget through. In addition, there are
            // different behaviors across browsers, So manually triggering a click event fixes the issue.
            this.$el.trigger("click");
        },

        _isOnlySelection() {
            const selection = this.viewModel.selection;
            return selection.isSingle() && selection.get("widgets")[0] === this;
        },

        /**
         * Handles when a widget is clicked. If reselected, we enable the text editor editable mode
         * Note: avoid overwriting, the AbstractWidgetView has _clickHandler
         *
         * @private
         */
        _clickedHandler() {
            if (!this._isSelected || !this._isOnlySelection()) {
                this.textEditorController.updateEditorModelFromWidgetModel();
            }
        },

        /**
         * Handles when the widget is deselected
         * @private
         */
        _deselectHandler() {
            DomHandler.clearSelection();

            if (this._isOnlySelection()) {
                return;
            }

            this._isSelected = false;

            // Due to the introduction of composite widgets where group widgets are rendered after the composite widget has been rendered
            // this is deferred to ensure existing (deferred) group widget renderings are done
            _.defer(() => {
                this.textEditorController.disableEditable();
            });
        },

        /**
         * OverWrites the textWidgetView update rendering
         */
        updateRendering() {
            this.__super();

            const attrs = WebFontsUtil.getFontAttributes(this.model);
            this.$el.attr(attrs);

            if (!this.textEditorController) {
                this.textEditorController = new TextEditorController(this);
            }
        },

        onClose() {
            this.__super();
            this.textEditorController.close();
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/textWidget/TransformableTextWidget.js